module.exports = __webpack_public_path__ + "img/store.5657b93e.jpg";